module.exports = __webpack_public_path__ + "static/NW_KP_Bild_Portr_1_a-115bf7a64920557ee3107668d2017b23.jpg";